import type { FaireProductEntity } from "../../entity_types/product";

export const p_9a6rvrpwrv: FaireProductEntity = {
  token: "p_9a6rvrpwrv",
  type: "product",
  name: "Carmelina Luxury Non-toxic Candle",
  brandToken: "b_rp9e5zdxjc",
  brandName: "Wilkin & May",
  imageUrl:
    "https://cdn.faire.com/fastly/7c9fbc21b94c6aff5a509a8c7776249592a288476f93bec16e0b8e162c0bc934.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7aee2d47d5bcdc136d0fb82baa29a639ff4a65b96da9eb54115412dae76b65d1.png",
    "https://cdn.faire.com/fastly/042726facf9a08cbbae0a14405459bec24acdb1bbf506f03ccd387b794d476c2.jpeg",
    "https://cdn.faire.com/fastly/755c7555d11b2a8f53de096609eb58b03ea3e61cd5fa2910eef2b5214624f03f.jpeg",
    "https://cdn.faire.com/fastly/d052dcac3284b2f8d57cc8dbdc39f0249fade87c65d2d40f18d556c85b7d8a86.jpeg",
  ],
  priceDollars: 24,
  description:
    "Like golden light spilling across sun-warmed wood.\n\nCarmelina is resinous, grounding, and softly sweet. Bergamot and basil lift the fragrance into brightness, while oud and woods settle it with quiet depth. A final trace of vanilla lingers—warm, luminous, and effortlessly sophisticated. \n\nEvery detail is designed to feel intentional: hand-poured in small batches, a clean coconut wax blend for an elegant burn, and a vessel meant to live on long after the flame. Even the wax itself is skin-safe, melting into a balm you can carry beyond the room. \n\nHand-poured in California in small batches\n\nClean-burning coconut wax blend\n\nSkin-safe wax doubles as a nourishing balm\n\n40+ hours burn time\n\nLead-free cotton wick\n\nReusable glass vessel with timeless design\n\nPhthalate-free, paraben-free, cruelty-free\n\nSustainable, biodegradable wax & packaging\n\nFragrance oils infused with natural botanicals\n\nLuxury positioning: refined, boutique, gift-worthy",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:47.553Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
